interface SourceSectionEmptyHintProps {
  sectionLabel: string;
}

const SourceSectionEmptyHint = ({ sectionLabel }: SourceSectionEmptyHintProps) => (
  <p className="tw-text-xs tw-text-muted-foreground">
    No records yet — add one if this facility uses {sectionLabel.toLowerCase()}.
  </p>
);

export default SourceSectionEmptyHint;
